// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DialogsHub.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import { observer } from 'mobx-react';
import { assign } from 'lodash/fp';
import { BASE_PADDING_TOP_WITH_PARENT_PIXEL } from 'logic/data/Izenda.UIConstants';
import DialogContainer from 'share/components/hoc/Izenda.DialogContainer';
const FIRST_LEVEL = 1;

const Dialog = observer(props => {
  const info = props.info;
  const countOfPaddingTop = info.level - FIRST_LEVEL;

  info.props = assign(
    {
      style: {
        paddingTop: countOfPaddingTop * BASE_PADDING_TOP_WITH_PARENT_PIXEL
      }
    },
    info.props
  );

  return React.createElement(DialogContainer(info.type), info.props);
});

const DialogsHub = observer(props => {
  const dialogNode = props.dialog;
  const children = dialogNode
    ? [
        React.createElement(Dialog, {
          key: 'dialog_' + dialogNode.info.name,
          info: dialogNode.info
        }),
        React.createElement(DialogsHub, {
          key: 'dialoghub_' + dialogNode.info.name,
          dialog: dialogNode.child
        })
      ]
    : null;
  const keyedProps = dialogNode ? { key: dialogNode.info.name } : null;

  return React.createElement('div', keyedProps, children);
});

export default DialogsHub;



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.DialogsHub.js